import { grey } from '@ant-design/colors';
import { Button, Divider, Form, Input, Typography } from 'antd';
import React, { Fragment, useCallback } from 'react';
import { Login2Icon } from "@solar-icons/react/outline/login-2";
import { UserRoundedIcon } from "@solar-icons/react/outline/user-rounded";
import { LockIcon } from "@solar-icons/react/outline/lock";
import { useDispatch, useSelector } from 'react-redux';
import { login } from '../../../redux/reducer/auth';
import { useEffect } from 'react';
import { loadVersionLast } from '../../../redux';
import moment from 'moment';
import Config from '../../../config/env';

const { Title } = Config
export default ({ apps }) => { // eslint-disable-line
    const dispatch = useDispatch();
    const { versionLastCache: beVersion } = useSelector(state => state.apps);

    const onFinished = useCallback((values) => {
        dispatch(login({ ...values, app: apps }));
    }, []) // eslint-disable-line

    useEffect(() => {
        dispatch(loadVersionLast());
    }, [])

    const containerStyle = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        width: '100vw',
        padding: '48px 16px',
        background: 'linear-gradient(135deg, #eef2ff 0%, #e0f2fe 100%)',
    };

    const formCardStyle = {
        width: '100%',
        maxWidth: 420,
        padding: '40px 44px',
        background: '#ffffff',
        borderRadius: 28,
        boxShadow: '0 28px 64px rgba(15, 23, 42, 0.14)',
        border: '1px solid rgba(148, 163, 184, 0.12)',
    };

    const labelStyle = { color: '#334155', fontWeight: 600 };

    const inputStyle = {
        borderRadius: 14,
        borderColor: 'rgba(148, 163, 184, 0.35)'
    };

    return (
        <Fragment>
            <div style={containerStyle}>
                <Form
                    title={`Login To ${apps}`}
                    layout='vertical'
                    style={formCardStyle}
                    labelAlign='left'
                    onFinish={onFinished}
                    requiredMark={false}
                >
                    <Typography.Title level={3} style={{ textAlign: 'center', marginBottom: 4, color: '#0f172a' }}>{Title} | LOGIN PJT</Typography.Title>
                    <Typography.Paragraph style={{ textAlign: 'center', color: '#64748b', marginBottom: 28 }}>
                        Masuk untuk melanjutkan akses aplikasi <br />IACAS.
                    </Typography.Paragraph>
                    <Divider style={{ margin: '0 0 28px', borderColor: '#e2e8f0' }} />
                    <Form.Item name={'user'} label={<span style={labelStyle}>Username</span>} rules={[{ required: true, message: 'Username Required' }]}>
                        <Input
                            autoFocus
                            size='large'
                            placeholder='Masukkan username'
                            prefix={<UserRoundedIcon color='#94a3b8' />}
                            style={inputStyle}
                        />
                    </Form.Item>
                    <Form.Item name={'password'} label={<span style={labelStyle}>Password</span>} rules={[{ required: true, message: 'Password Required' }]}>
                        <Input.Password
                            size='large'
                            placeholder='Masukkan password'
                            prefix={<LockIcon color='#94a3b8' />}
                            style={inputStyle}
                        />
                    </Form.Item>
                    <Button
                        icon={<Login2Icon style={{ marginInline: 5 }} />}
                        block
                        htmlType="submit"
                        type='primary'
                        size='large'
                        style={{
                            border: 'none',
                            borderRadius: 14,
                            boxShadow: '0 18px 40px rgba(56, 60, 69, 0.25)',
                            fontWeight: 600,
                            letterSpacing: 0.3,
                            marginTop: 12,
                        }}
                    >
                        Login
                    </Button>
                    <div style={{ textAlign: 'center', marginTop: 36, color: '#64748b' }}>
                        <span>COPYRIGHT © {moment().format("YYYY")} <a target={'_blank'} href="https://edifly-si.com/" style={{ color: '#2563eb', fontWeight: 500 }}>Edifly Solusi Indonesia</a></span>
                    </div>
                </Form>
            </div>
        </Fragment>
    )
}